module.exports = __webpack_public_path__ + "static/assets/82be34b98c2cdc3b0a96e05484ccbc2b.png";